import React, {useContext, useEffect} from 'react'
import {OfferEditContext} from "../../../context/OfferUpdateContext";
import config from "../../../config";
import {Form, Select} from "antd";
import {replaceIndexAt} from "../../../utils/helpers/commonFunctions";


const {Option} = Select

const OfferUpdateCurrency = ({rowIndex, record}) => {
    const [form] = Form.useForm()
    const {bidContent} = useContext(OfferEditContext)
    const [bidList, setBidList] = bidContent

    useEffect(() => {
        form.setFieldsValue({
            [`currencySelect_${rowIndex}`]: record.selectedCurrency
        })
    }, [rowIndex, record])

    const handleCurrencyChange = () => {
        const formItems = form.getFieldsValue()
        const createList = replaceIndexAt(
            bidList,
            {
                ...record,
                selectedCurrency: formItems[`currencySelect_${rowIndex}`]
            },
            rowIndex
        )
        setBidList(createList)
    }

    return(
        <React.Fragment>
            <Form form={form}>
                <Form.Item name={`currencySelect_${rowIndex}`}>
                    <Select onChange={handleCurrencyChange}>
                        {
                            config.currencyOptions.map(item => <Option key={item} value={item} >{item}</Option>)
                        }
                    </Select>
                </Form.Item>
            </Form>
        </React.Fragment>
    )
}
export default OfferUpdateCurrency